import { InjectionToken } from '@angular/core';

export interface CbreHttpConfig {
  /**
   * Base url for making all the request
   */
  baseUrl: string;
  /**
   * To skip Span interceptor to run over an specific set of url patterns (desired
   * for path patterns like assets and if HttpTransporter is a must to include the
   * logging path so stats don't create an infinite loop since @cbre/http has dependency
   * with logger and logger performs http calls if HttpTransport is provided)
   */
  skipUrlInterception: string[];
  /**
   * by default Request-Id is the header name for atomic calls, if header name is different
   * then this attribute has to be specified
   * @example
   * requestIdHeaderName: 'span-id'
   */
  requestIdHeaderName?: string;
  /**
   * by default Transaction-Id is the header name for transactional calls, if header name is different
   * then this attribute has to be specified
   * @example
   * transactionIdHeaderName: 'x-transactional-id'
   */
  transactionIdHeaderName?: string;
}

/**
 * Injection Token for CbreHttpConfig dependency
 */
export const CbreHttpConfigToken = new InjectionToken<CbreHttpConfig>('CbreHttpConfig');
